import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.TypeFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'type'
  alias: 'Source'
  facetName: 'type'
  humanize: true
  selectAll: true
  visibleInMyHistorySession: false

  getAppliedValues: ->
    return @searchQuery.get('type')

  addFilter: (value) ->
    @searchQuery.addType(value)

